import styled from '@emotion/styled';
import React from 'react';

import chevronIcon from 'src/public/img/icon-chevron.svg';
import { color } from 'src/shared/styles/variables';

interface StyledIconProps {
    iconUrl: string;
    onClick?: () => void;
}

const BackArrowStyle = styled('i')<StyledIconProps>(({ iconUrl }) => ({
    display: 'inline-block',
    backgroundImage: `url('${iconUrl}')`,
    height: '1.5rem',
    width: '1.5rem',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'center',
    border: 'none',
    transform: 'scaleX(-1)',
}));

export enum BackArrowTestID {
    Button = 'BackArrow.Button',
}

export const BackArrow = props => (
    <div
        {...props}
        data-testid={BackArrowTestID.Button}
        style={{
            backgroundColor: color.catskillWhite,
            margin: 10,
            display: 'flex',
            borderRadius: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            height: '3.5rem',
            width: '3.5rem',
            cursor: 'pointer',
            ...props.style,
        }}
    >
        <BackArrowStyle iconUrl={chevronIcon} />
    </div>
);
